import React, { Component, Fragment } from 'react';
import i18n from '../../../plugins/i18n/i18n'
import { NavLink } from 'react-router-dom'
import { actions } from '../../../store/modules';
import { connect } from 'react-redux';
import { Input, Form, Button, Checkbox, Row, Col, Spin } from 'antd';
import { errorMessageNotification } from '../../../helpers/index'
import queryString from "query-string";


class SignInExternal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadings: {
        first: true
      },
      loginSuccess: null,
      errorMessage: null,
      check: null
    }
  }

  componentDidMount() {
    setTimeout(() => {
      let { loadings } = this.state;
      loadings.first = false;
      this.setState({ loadings });
      this.fetchRoute();
    }, 2000);


  }

  fetchRoute = () => {

    let { check } = this.state;

    if (check && check.isAvailableForLogin) {
      this.fetchLogin()
    } else {
      this.fetchCheck()
    }
  }




  fetchLogin = () => {

    this.setState({ loading: true })

    let _this = this;
    let params = queryString.parse(window.location.search);

    var param = {
      username: params.email
    }

    this.props.dispatch(actions.auth.loginExternal(param))
      .then(() => window.location.pathname = "/app/trips")
      .catch(error => {

        let responseErrorMessage = JSON.parse(JSON.stringify(error)).response.data.error_description;
        this.setState(
          {
            loading: false,
            loginSuccess: false,
            errorMessage: responseErrorMessage

          },
          () => {
            setTimeout(() => {
              _this.setState({ loginSuccess: null });
            }, 3500);
          })
      })
  }

  fetchCheck = () => {

    this.setState({ loading: true })
    let _this = this;


    let params = queryString.parse(window.location.search);
    if (params && !params.email) {
      this.props.history.push(
        `/auth/sign-in`
      );
      return;
    }


    var param = {
      email: params.email,
    }

    this.props.dispatch(actions.auth.check(param))
      .then((response) => {
        this.setState({ check: response })

        if (!response.isRegistered) {

          this.props.history.push(
            `/auth/register?email=${params.email}`
          )

        } else {

          this.fetchLogin()

          // this.setState(
          //   {
          //     loading: false,
          //     loginSuccess: response.isAvailableForLogin ? true : false,
          //     errorMessage: response.loginMessage
          //   },
          //   () => {
          //     setTimeout(() => {
          //       _this.setState({ loginSuccess: null });
          //     }, 3500);
          //   })
        }



      }
      )
      .catch(error => {
        this.setState(
          {
            loading: false,
            loginSuccess: false,
            errorMessage: errorMessageNotification(error)

          },
          () => {
            setTimeout(() => {
              _this.setState({ loginSuccess: null });
            }, 3500);
          })
      })
  }

  render() {

    let { loading, loadings, loginSuccess, errorMessage, check } = this.state;

    return (
      <div className="auth-content">

        {
          loadings.first &&
          <div className="ant-loading loading-content">
            <Spin
              tip={`${i18n.t(`loading`, {
                lng: this.props.currentLanguage,
              })}`}
            />
          </div>
        }

        {
          !loadings.first &&
          <h1 className="heading">
            Devam etmek için lütfen e-posta adresinizi giriniz
          </h1>

        }
        {
          !loadings.first &&
          <div className='form-box'>

            <Form
              layout="vertical"
              onFinish={this.fetchRoute}>

              <Form.Item
                label="E-posta Adresi"
                name="email"
                rules={[
                  {
                    type: "email",
                    message: i18n.t("emailInvalid")
                  },
                  {
                    required: true,
                    message: `${i18n.t("fieldIsRequired", {
                      lng: this.props.currentLanguage,
                    })}`,
                  }
                ]}
              >
                <Input
                  type="email"
                  placeholder="e-posta@alanadi.com"
                />
              </Form.Item>

              {

                check && check.isAvailableForLogin &&

                <Fragment>

                  <Form.Item
                    label={`${i18n.t("password", {
                      lng: this.props.currentLanguage,
                    })}`}
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: `${i18n.t("fieldIsRequired", {
                          lng: this.props.currentLanguage,
                        })}`,
                      }
                    ]}
                  >
                    <Input.Password
                      placeholder={i18n.t("typeYourPassword", {
                        lng: this.props.currentLanguage,
                      })}
                    />
                  </Form.Item>

                  <Row>
                    <Col span={12}>
                      <Form.Item
                        name="remember"
                        valuePropName="checked"
                      >
                        <Checkbox>Beni hatırla</Checkbox>
                      </Form.Item>
                    </Col>
                    <Col span={12}>

                      <Form.Item>
                        <NavLink
                          to="/auth/forgot-password"
                          className="btn-link"
                          style={{ float: "right" }}
                        >
                          {i18n.t('forgotPassword', { lng: this.props.currentLanguage })}
                        </NavLink>
                      </Form.Item>

                    </Col>
                  </Row>
                </Fragment>

              }

              <div
                className="error"
                style={
                  loginSuccess === false
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                {errorMessage}
              </div>


              <Form.Item>
                <Button
                  className="width-100"
                  htmlType="submit"
                  type="primary"
                  loading={loading}
                >
                  {
                    check && check.isAvailableForLogin ?
                      i18n.t('signIn', { lng: this.props.currentLanguage })
                      :
                      i18n.t('continue', { lng: this.props.currentLanguage })
                  }

                </Button>
              </Form.Item>
            </Form>

          </div>
        }
      </div>
    )
  }
}


const mapStateToProps = ({ auth }) => ({
  ...auth
});
export default connect(mapStateToProps)(SignInExternal);





// WEBPACK FOOTER //
// ./src/components/Auth/Views/SignInExternal.js